import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface loadingSlice {
  isLoading: boolean;
}

const initialLoadingState: loadingSlice = {
  isLoading: false,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState: initialLoadingState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setIsLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
